export default __webpack_public_path__ + "static/media/scan.73b4d68c.svg";